export enum RENEWABLE_ENERGY {
  SOLAR = "solar",
  WIND = "wind",
  HUDRO = "hydro",
}
